import React, { useEffect, useState } from "react";
import "./ProfStepper.css";
import { TiTick } from "react-icons/ti";
import useIsMobile from "Hooks/useIsMobile";
const ProfStepper = ({
  currentStep, 
  isCaseOpen
}) => {
 
  const initialsteps = ["Requested", "Approved", "Conflict cleared", "Requested to close", "Case Closed"];
  const [stepsTerms, setStepsTerms] = useState(initialsteps);
  const isMobile = useIsMobile();
   useEffect(() => {
    if(isMobile)
    {
    setStepsTerms(["Requested", "Approved", "No Conflict", "Req to close", "Closed"]);
    }
  },[])
  const [stepsAnimate, setStepsAnimate] = useState(currentStep);
  const [disable, setDisable] = useState();
  const getStepFromResp = (data) => {
    if(data?.caseStatus)
    {
      switch(data?.caseStatus)
      {
        case "requested":
          return 1;
          case "approved":
          return 2;
          case "noConflict":
          return 3;
          case "reqToClose":
            return 4;
            case "closed":
            return 5;
            default:
              return 1
      }
    }
  }
  useEffect(() => {
        
        setStepsAnimate(getStepFromResp(currentStep));
        (!isCaseOpen && stepsAnimate !== 5 ? setDisable(true) : setDisable(false));
    
  },[currentStep])
  return (
    <>
      <div className="flex justify-center w-full lg:pt-10 ">
        {stepsTerms?.map((step, i) => (
          <div
            key={i}
            className={`step-item ${stepsAnimate === i + 1 && "active"} ${
              (i + 1 <= stepsAnimate) && "complete"
            } `}
          >
              <div className={"step"+ (i + 1 <= stepsAnimate && !disable ? " bg-green-700" : " bg-gray-700")}>
                {i + 1 <= stepsAnimate ? <div className={"border-2  rounded-full lg:p-2"+ (disable ? " bg-gray-600" : " bg-green-600")}><TiTick className="lg:block hidden" size={24} /></div> : 
                <div className="lg:h-4 w-2 h-2 lg:w-4 bg-gray-400 rounded-full"></div>
                }
              </div>
              <p className={"text-[10px] lg:text-base text-gray-500 " + (i + 1 <= stepsAnimate && !disable ? " text-green-700" : " text-gray-700")}>
                {step}
              </p>
              {currentStep - 1 === i ? 
              <div className={"absolute border-[19px] border-t-0 border-r-transparent border-l-transparent  h-0 w-0 -bottom-6"+ (disable ? " border-b-gray-300" : " border-b-green-100")}></div> : ''}
          </div>
        ))}
      </div>
    </>
  );
};

export default ProfStepper;